import React from 'react';
import { InputNumber, Text } from '@clockout-dev/design-elements';
import ConfigurationCard from '../../../../common/configurationCard/ConfigurationCard';
import styles from '../styles/limitsForm.module.scss';

function FeeCapCard({ value, enabled, onChange, onToggleEnabled }) {
    return (
        <ConfigurationCard
            title="Fee Cap"
            description="The maximum amount of fees a user can incur per pay cycle"
            togglePosition="leading"
            enabled={enabled}
            onToggleEnabled={onToggleEnabled}
        >
            <div className={styles.cardInputRow}>
                <InputNumber
                    value={value}
                    prefix="$"
                    onChange={onChange}
                    min={0}
                    max={9999.99}
                    step={0.01}
                    precision={2}
                    controls={false}
                    className={`${styles.inlineNumberInput} ${styles.amountField}`}
                />
                <Text as="span" size="s" className={styles.ruleLabel}>dollars per pay cycle</Text>
            </div>
        </ConfigurationCard>
    );
}

export default FeeCapCard;
